import { Mail, Phone, MapPin, Clock, Truck } from "lucide-react";
import { Reveal, PageHero } from "@/components/bits";
import { ContactForm } from "@/components/forms";
import { COMPANY } from "@/lib/data";

function InfoCard({ icon: Icon, title, children, testid, delay }) {
  return (
    <Reveal delay={delay}>
      <div className="card p-7" data-testid={testid}>
        <div className="h-11 w-11 rounded-2xl bg-signal/10 flex items-center justify-center"><Icon className="h-5 w-5 text-corpblue" /></div>
        <h3 className="mt-4 font-display font-bold text-ink">{title}</h3>
        {children}
      </div>
    </Reveal>
  );
}

export default function ContactPage() {
  return (
    <main>
      <PageHero
        overlap
        eyebrow="Contact Us"
        title="Talk to a dispatcher, not a phone tree."
        testid="contact-page-title"
        lead="Questions about a lane, a load in transit, or working with us — we answer around the clock."
      />

      <section className="pb-16 lg:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start relative z-10 -mt-24 lg:-mt-28">
          <div className="lg:col-span-4 space-y-5">
            <InfoCard icon={Mail} title="Email" testid="contact-card-email" delay={0}>
              <a href={`mailto:${COMPANY.email}`} data-testid="contact-card-email-link" className="mt-1 block text-[15px] text-slate-600 hover:text-corpblue transition-colors break-all">
                {COMPANY.email}
              </a>
            </InfoCard>
            <InfoCard icon={Phone} title="24/7 Dispatch" testid="contact-card-phone" delay={0.08}>
              <a href={`tel:${COMPANY.phone.replace(/[^+\d]/g, "")}`} data-testid="contact-card-phone-link" className="mt-1 block text-[15px] text-slate-600 hover:text-corpblue transition-colors">
                {COMPANY.phone}
              </a>
            </InfoCard>
            <InfoCard icon={MapPin} title="Coverage" testid="contact-card-coverage" delay={0.16}>
              <p className="mt-1 text-[15px] text-slate-600 leading-relaxed">
                {COMPANY.location} — hubs at the ports of LA, Long Beach and Oakland, with lanes across the Southwest.
              </p>
            </InfoCard>
            <Reveal delay={0.24}>
              <div className="panel-reference p-7" data-testid="contact-card-hours">
                <Clock className="h-6 w-6 text-gold" />
                <h3 className="mt-4 font-display font-bold text-white">Dispatch hours</h3>
                <p className="mt-1 text-[15px] text-slate-300 leading-relaxed">24 hours, 7 days a week — freight doesn't keep office hours and neither do we.</p>
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="card p-7 flex items-start gap-4" data-testid="contact-card-trucking">
                <Truck className="h-6 w-6 text-corpblue shrink-0" />
                <p className="text-sm text-slate-600 leading-relaxed">
                  <span className="font-display font-bold text-ink">Carrier or agent?</span> Use the
                  dedicated pages under Carriers and Agents above — forms route straight to the right desk.
                </p>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.12}>
              <ContactForm />
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
